/**
 * One map look, shared by every Google map in the booking flow.
 *
 * This is the pin picker's palette — the pale blue-grey ground with the roads
 * stepped from highway to local, and every label kept quiet. It was written for
 * "Choose from Map" and lived inside that component; the journey rail's route
 * preview meanwhile left Google's own colours alone. Two maps of the same city,
 * a step apart in the same booking, looking nothing like each other.
 *
 * Both read from here now, so the picker the reader drops a pin on and the
 * strip that shows them the route back are the same map.
 *
 * Left structurally typed rather than annotated as `google.maps.MapTypeStyle[]`:
 * google-map-react declares its own `options.styles` shape, and pinning this to
 * the Maps typings makes it unassignable there. Each caller asserts to whatever
 * its own map wants.
 */
export const YELO_MAP_STYLE = [
  // Map background
  {
    featureType: "all",
    elementType: "geometry",
    stylers: [{ color: "#E8EAF0" }],
  },
  // Roads - Main highways
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#7B9BC7" }, { weight: 3 }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#6B8BB7" }, { weight: 1 }],
  },
  // Roads - Major roads
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#A8B8D8" }, { weight: 2 }],
  },
  // Roads - Local roads
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#C5D1E8" }, { weight: 1 }],
  },
  // Water bodies
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#B8CAE8" }],
  },
  // Parks and green areas
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#DDE2ED" }],
  },
  // Buildings
  {
    featureType: "poi.business",
    elementType: "geometry",
    stylers: [{ color: "#D5DAE5" }],
  },
  // Labels - Main text
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [{ color: "#5A6B7A" }],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#FFFFFF" }, { weight: 2 }],
  },
  // Administrative labels
  {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{ color: "#4A5A6A" }],
  },
  // Hide unnecessary elements
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "transit",
    elementType: "labels",
    stylers: [{ visibility: "simplified" }],
  },
  // Road labels
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#4A5A6A" }],
  },
  // Landscape
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#E8EAF0" }],
  },
  // Transit stations
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [{ color: "#C8D4E8" }],
  },
];
